module.exports = __webpack_public_path__ + "static/media/1.a5a40f6a.jpg";